/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import { VueQueryPlugin } from '@tanstack/vue-query'
import pinia from '@/stores'
import router from '@/router'
import { getQueryClient } from '@/libs/query/client'

export function registerPlugins(app) {
  app.use(vuetify).use(VueQueryPlugin, { queryClient: getQueryClient() }).use(pinia).use(router)
}
